<ft-modal-overlay [open]="true">
    <ft-modal-chrome-ng modalClass="ft-broadcast-modal" size="full" [doneVisible]="false" [cancelVisible]="false">
        <ft-initialized-content [isInitialized]="isInitialized">
            @if (stepActive('ChooseGoal')) {
                <div>
                    <button class="ft-btn-close" (click)="close()"></button>

                    <div class="ft-modal-view choose-goal">
                        <h1 class="modal-heading">What's your goal for this broadcast?</h1>
                        <ft-broadcast-choose-goal-ng [story]="story" [contests]="contests"
                                                     (inviteToStory)="startLeadShare()"
                                                     (inviteToContest)="startStorytellersShare($event)"
                                                     (inviteToWebsite)="startWebsiteInviteShare()" />
                    </div>
                </div>
            }
            @if (stepActive('StoryShareImageSetup')) {
                <div>
                    <button class="ft-btn-close" (click)="close()"></button>
                    <a class="ft-btn ft-btn-outline-light ft-btn-back" [hidden]="!(contests?.length > 1)" (click)="chooseDifferentGoal()">
                        Choose a different goal
                    </a>

                    <div class="ft-modal-view image-setup">
                        <h1 class="modal-heading">Let's set up your content.</h1>
                        <p class="modal-summary">
                            Use the editor to set up content that will display with your broadcast. The final appearance may be adjusted for the channels you select in the next step.
                        </p>

                        <ft-story-image-setup-ng [story]="story" [property]="property" [options]="imageSetupOptions" />

                        <button type="button" class="ft-btn ft-btn-plus-1 ft-btn-default ft-btn-confirm" (click)="finishImageSetup()">
                            Continue
                        </button>
                    </div>
                </div>
            }
            @if (stepActive('PhotocontestInvitationShareImageSetup')) {
                <div>
                    <button class="ft-btn-close" (click)="close()"></button>
                    <a class="ft-btn ft-btn-outline-light ft-btn-back" (click)="chooseDifferentGoal()">
                        Choose a different goal
                    </a>

                    <div class="ft-modal-view image-setup">
                        <h1 class="modal-heading">Let's set up your content.</h1>
                        <p class="modal-summary">
                            Use the editor below to set up content to display to your audience. The final appearance may differ
                            based on the channels you select in the next step.
                        </p>

                        <ft-story-image-setup-ng [story]="story" [property]="property" [options]="imageSetupOptions" />

                        <button type="button" class="ft-btn ft-btn-plus-1 ft-btn-default ft-btn-confirm" (click)="finishImageSetup()">
                            Continue
                        </button>
                    </div>
                </div>
            }
            @if (stepActive('ChooseNetwork')) {
                <div>
                    <button class="ft-btn-close" (click)="close()"></button>
                    <a class="ft-btn ft-btn-outline-light ft-btn-back" (click)="returnToImageSetup()">
                        Return to set up your content
                    </a>
                    <div class="ft-modal-view choose-channel">
                        <h1 class="modal-heading">Which channel do you want to broadcast to?</h1>

                        <ft-broadcast-choose-network-ng [sharedTo]="storySharedTo"
                                                        (openShareModal)="openShareModal($event)" />

                        <p class="ft-share-to-links-caption">
                            A preview will be provided on the next step.
                            <br />
                            You can also broadcast this story multiple times&mdash;we'll return to this screen
                            after you're done with a channel.
                        </p>
                    </div>
                </div>
            }
            @if (stepActive('CreateImageProgress')) {
                <div>
                    <button class="ft-btn-close" (click)="close()"></button>
                    <div class="ft-modal-view rendering-image">
                        <div class="ft2-spinner -large"></div>
                        <h1 class="modal-heading">{{ 'flipto.account.CreatingImage' | translate }}</h1>
                    </div>
                </div>
            }
            @if (stepActive('ShareImageReady')) {
                <div>
                    <button class="ft-btn-close" (click)="close()"></button>
                    <a class="ft-btn ft-btn-outline-light ft-btn-back" (click)="chooseDifferentChannel()">Choose a different
                        channel</a>

                    <ft-broadcast-share-image-ready-ng [first]="story?.guest?.first"
                                                       [shareImageUrl]="shareImageUrl"
                                                       [network]="network"
                                                       [shareUrl]="shareUrl"
                                                       [shareType]="shareType"
                                                       (reprocessImage)="reprocessImage()"
                                                       (downloadShareImage)="downloadShareImage()"
                                                       (share)="openOAuth($event)"
                                                       [isRecommendationSetup]="false" />
                </div>
            }
        </ft-initialized-content>
    </ft-modal-chrome-ng>
</ft-modal-overlay>
